const ARTIFACT_RELOAD_GUARD_STORAGE_KEY = "business_context_artifact_reload_guard_v1"
const ARTIFACT_RELOAD_GUARD_WINDOW_MS = 60_000

interface ReloadAttempt {
  frontendModuleVersion: string
  attemptedAt: number
}

function readAttempt(): ReloadAttempt | undefined {
  try {
    const raw = sessionStorage.getItem(ARTIFACT_RELOAD_GUARD_STORAGE_KEY)
    if (!raw) return undefined
    const parsed = JSON.parse(raw)
    return parsed
      && typeof parsed === "object"
      && !Array.isArray(parsed)
      && typeof parsed.frontendModuleVersion === "string"
      && typeof parsed.attemptedAt === "number"
      ? parsed as ReloadAttempt
      : undefined
  } catch {
    return undefined
  }
}

function writeAttempt(attempt: ReloadAttempt) {
  try {
    sessionStorage.setItem(
      ARTIFACT_RELOAD_GUARD_STORAGE_KEY,
      JSON.stringify(attempt),
    )
  } catch {
    // If sessionStorage is unavailable, allow the normal one-shot reload.
  }
}

/**
 * Blocks only a consecutive retry to the same moduleType=4 artifact. An
 * intervening transition proves the user deliberately crossed artifacts and
 * must allow a later return even inside the guard window.
 */
export function claimFrontendArtifactReload(
  frontendModuleVersion: string,
  now = Date.now(),
) {
  if (!frontendModuleVersion) return false
  const previousAttempt = readAttempt()
  if (
    previousAttempt?.frontendModuleVersion === frontendModuleVersion
    && now >= previousAttempt.attemptedAt
    && now - previousAttempt.attemptedAt <= ARTIFACT_RELOAD_GUARD_WINDOW_MS
  ) {
    writeAttempt(previousAttempt)
    return false
  }
  writeAttempt({
    frontendModuleVersion,
    attemptedAt: now,
  })
  return true
}
